import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { BillComparisonFormVm } from 'app/shared/generated/Forms/Models/BillComparisonFormVm';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SecurityService } from 'app/core/security/security.service';

@Component({
    selector: 'pcg-bill-comparison',
    templateUrl: './bill-comparison.component.html',
    styleUrls: ['./bill-comparison.component.scss'],
    standalone: false
})
export class BillComparisonComponent implements OnInit {

	@Input() BillComparisonFormId = 0;
	@Input() UserEmail = ""
	formGroup = BillComparisonFormVm.Form;
	model = BillComparisonFormVm.GetModel(this.formGroup);
	canEdit: boolean;
	code: string;
	subscriptions = new Subscription();
	utilityProviderId : number;
	

	constructor(
		public title: Title,
		private ms: SystemMessageService,
		private httpClient: HttpClient,
		private route: ActivatedRoute,
		private sec: SecurityService,
		public router: Router
	) {
		title.setTitle('Monthly Bill Comparison')
	 }

	ngOnInit() {
		this.formGroup.patchValue(this.model);
		this.formGroup.controls['providerCompanyId'].patchValue(this.utilityProviderId);
		this.addRouteSubscription();
		
		this.utilityProviderId = this.model.providerCompanyId;
		this.canEdit = this.model.canEdit;
	}

	openWindow = (o: string) => { this.router.navigateByUrl('/' + o); };

	SaveModel() {
		this.convertFormStringsToNumbers();
		this.formGroup.value.billDate = Date.now();
		this.formGroup.controls['userEmail'].patchValue(this.UserEmail);
		this.subscriptions.add(
			this.ms
				.getHttpObservable(this, "api/Forms/BillComparisonForm/SaveModel", this.formGroup)
				.subscribe(msg => {
						if(!msg.model.isAdmin) {
							this.canEdit = false;
						}
						if(msg.isSuccessful)
						{
							this.model.submittedBy = msg.model.fullName;
						}
					
						this.formGroup.patchValue(this.model);
						this.formGroup.controls['providerCompanyId'].patchValue(this.utilityProviderId);
						this.addRouteSubscription();
				})
		);
	}

	onSubmit()
	{
		if(!this.formGroup.valid) {
			this.ms.setSystemMessage("All fields are requried.", "error");
			return;
		}
		
		this.convertFormStringsToNumbers();
		this.formGroup.value.billDate = Date.now();
		this.formGroup.controls['userEmail'].patchValue(this.UserEmail);
		this.subscriptions.add(
			this.httpClient
				.post("api/Forms/BillComparisonForm/CheckTenPercentRule", this.formGroup.getRawValue())
				.subscribe((msg:SystemMessage) => {
						if(!msg.isSuccessful){
							if(confirm(msg.message)){
								this.SaveModel();
							}
						}
						else{
							this.SaveModel();
						}
				})
		);
	}

	addRouteSubscription() {
		this.subscriptions.add(
			this.route.paramMap.subscribe(map => {
				if(this.BillComparisonFormId==0)
				{
					this.BillComparisonFormId = parseInt(map.get('id'),10);
				}
				const httpParams = new HttpParams().set('billComparisonFormId', this.BillComparisonFormId).set('userEmail', this.UserEmail);
				this.subscriptions.add(
					this.httpClient
						.get('api/Forms/BillComparisonForm/GetModel', {
							params: httpParams,
						  })
						.subscribe((model: BillComparisonFormVm) => {
							this.formGroup.patchValue(model);
							this.canEdit = this.formGroup.value.canEdit;
						})
				);
			})
			
		)
		
	}

	convertFormStringsToNumbers () {
		this.formGroup.value.baseRate1000KWH = Number(this.formGroup.value.baseRate1000KWH)
		this.formGroup.value.baseRate1200KWH = Number(this.formGroup.value.baseRate1200KWH)
		this.formGroup.value.baseRate2500KWH = Number(this.formGroup.value.baseRate2500KWH)
		this.formGroup.value.baseRate750KWH = Number(this.formGroup.value.baseRate750KWH)
		this.formGroup.value.baseRate1500KWH = Number(this.formGroup.value.baseRate1500KWH)
		this.formGroup.value.baseRate30KW6000KWH = Number(this.formGroup.value.baseRate30KW6000KWH)
		this.formGroup.value.baseRate40KW10000KWH = Number(this.formGroup.value.baseRate40KW10000KWH)
		this.formGroup.value.baseRate75KW15000KWH = Number(this.formGroup.value.baseRate75KW15000KWH)
		this.formGroup.value.baseRate75KW30000KWH = Number(this.formGroup.value.baseRate75KW30000KWH)
		this.formGroup.value.baseRate150KW30000KWH = Number(this.formGroup.value.baseRate150KW30000KWH)
		this.formGroup.value.baseRate150KW60000KWH = Number(this.formGroup.value.baseRate150KW60000KWH)
		this.formGroup.value.baseRate300KW60000KWH = Number(this.formGroup.value.baseRate300KW60000KWH)
		this.formGroup.value.baseRate300KW1200000KWH = Number(this.formGroup.value.baseRate300KW1200000KWH)
		this.formGroup.value.baseRate500KW100000KWH = Number(this.formGroup.value.baseRate500KW100000KWH)
		this.formGroup.value.baseRate500KW200000KWH = Number(this.formGroup.value.baseRate500KW200000KWH)
		this.formGroup.value.fuelAdj1000KWH = Number(this.formGroup.value.fuelAdj1000KWH)
		this.formGroup.value.fuelAdj1200KWH = Number(this.formGroup.value.fuelAdj1200KWH)
		this.formGroup.value.fuelAdj2500KWH = Number(this.formGroup.value.fuelAdj2500KWH)
		this.formGroup.value.fuelAdj750KWH = Number(this.formGroup.value.fuelAdj750KWH)
		this.formGroup.value.fuelAdj1500KWH = Number(this.formGroup.value.fuelAdj1500KWH)
		this.formGroup.value.fuelAdj30KW6000KWH = Number(this.formGroup.value.fuelAdj30KW6000KWH)
		this.formGroup.value.fuelAdj40KW10000KWH = Number(this.formGroup.value.fuelAdj40KW10000KWH)
		this.formGroup.value.fuelAdj75KW15000KWH = Number(this.formGroup.value.fuelAdj75KW15000KWH)
		this.formGroup.value.fuelAdj75KW30000KWH = Number(this.formGroup.value.fuelAdj75KW30000KWH)
		this.formGroup.value.fuelAdj150KW30000KWH = Number(this.formGroup.value.fuelAdj150KW30000KWH)
		this.formGroup.value.fuelAdj150KW60000KWH = Number(this.formGroup.value.fuelAdj150KW60000KWH)
		this.formGroup.value.fuelAdj300KW60000KWH = Number(this.formGroup.value.fuelAdj300KW60000KWH)
		this.formGroup.value.fuelAdj300KW1200000KWH = Number(this.formGroup.value.fuelAdj300KW1200000KWH)
		this.formGroup.value.fuelAdj500KW100000KWH = Number(this.formGroup.value.fuelAdj500KW100000KWH)
		this.formGroup.value.fuelAdj500KW200000KWH = Number(this.formGroup.value.fuelAdj500KW200000KWH)
		this.formGroup.value.customerCharge = Number(this.formGroup.value.customerCharge)
	}
	

	recertify ()
	{
		if(confirm("This will replace all the data in this form with the data from the previous month. Do you wish to continue?"))
		{
			this.subscriptions.add(
				this.httpClient
							.get(`api/Forms/BillComparisonForm/Recertify/${this.BillComparisonFormId}`)
							.subscribe((msg: SystemMessage) => {
								if(msg.isSuccessful)
								{
									location.reload();
								}
									
							})
					);
		}
	}

	

}
